// extracted by mini-css-extract-plugin
export default {"toolbar":"_601qd","share":"kOVbR"};